import React from 'react';
import { IdeaChatSidebar } from './IdeaChatSidebar';
import { IdeaChatMain } from './IdeaChatMain';

export function IdeaChat() {
  return (
    <div className="flex-1 flex overflow-hidden">
      <IdeaChatSidebar />
      <IdeaChatMain />
    </div>
  );
}
